import PropTypes from 'prop-types';

import { maxLength } from '../../const/formConst';
import useHandleGetTypesAndDomains from '../../hooks/useHandelGetTypesAdnDomains';
import ButtonNext from '../form-buttons/ButtonNext';
import SkeletonLoader from '../loader/SkeletonLoader';
import UploadedFile from './UploadedFile';

const FirstStep = () => {
  const {
    data,
    loading,
    currentStep,
    register,
    watchedType,
    countCharacters,
    currentNumber,
    typesList,
  } = useHandleGetTypesAndDomains();

  return (
    <>
      <div className="laForm__stage-item__sticky-header">
        <div className="laForm__stage-badge">Stage {currentStep.id}</div>
        <h2>
          Project <strong>basics</strong>
        </h2>
      </div>
      <div className="laForm__stage-item__wrapper">
        <div className="textarea-group">
          <label>Please provide some description of the idea</label>
          <textarea
            placeholder="I want to build booking app ..."
            maxLength={maxLength}
            defaultValue={data.description}
            {...register('description', { onChange: countCharacters })}
          />
          <div className="textarea-group__footer-wrap">
            <UploadedFile />
            <div className="textarea-group__counter">
              {currentNumber}/{maxLength}
            </div>
          </div>
        </div>

        <div>
          <fieldset className="tale-fieldset border-top">
            <legend>What type of software project are you planning?</legend>

            {loading && <SkeletonLoader />}
            {typesList.length > 0 &&
              typesList.map((item) => (
                <div key={item._id} className="tale-btn-group">
                  <input
                    type="radio"
                    id={item._id}
                    value={item._id}
                    className="hidden-input"
                    {...register('type')}
                  />
                  <label htmlFor={item._id} className="ic-check">
                    <div className={item.icon} data-name={item.name} />
                    <span>{item.name}</span>
                  </label>
                </div>
              ))}
          </fieldset>
        </div>
      </div>
      <div className="laForm__stage-item__btns">
        <ButtonNext
          stepId={currentStep.id}
          isDisabled={!watchedType}
          buttonId={`${currentStep.id}-project-basics`}
        />
      </div>
    </>
  );
};

export default FirstStep;

FirstStep.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  currentStep: PropTypes.object,
  countCharacters: PropTypes.func,
  currentNumber: PropTypes.number,
  typesList: PropTypes.array.isRequired,
};
